if (!customElements.get("animated-counter")) {
  class AnimatedCounter extends HTMLElement {
    constructor() {
      super();
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), { threshold: 0.5 });
      this.targetNumber = parseInt(this.getAttribute("target")) || 0;
      this.increment = Math.ceil(this.targetNumber / 100);
      this.currentValue = 0;
    }

    connectedCallback() {
      this.innerText = "0";
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer.disconnect();
    }

    handleIntersection(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.startCounting();
          this.observer.unobserve(this);
        }
      });
    }

    formatNumber(value) {
      if (value >= 10000) {
        const rounded = Math.floor(value / 1000);
        return `${rounded}k+`;
      }
      return `${value}+`;
    }

    startCounting() {
      const updateCounter = () => {
        this.currentValue = Math.min(this.currentValue + this.increment, this.targetNumber);
        this.innerText = this.formatNumber(this.currentValue);

        if (this.currentValue < this.targetNumber) {
          requestAnimationFrame(updateCounter);
        }
      };
      updateCounter();
    }
  }

  customElements.define('animated-counter', AnimatedCounter);
}
